// @flow
import type { State } from "@store/reducers";
import type { ApprovableContainer, HierarchyAssignment } from "@modules/service/types";
import type { Alert } from "@modules/service/reducer/alerts/types";
import { validateHierarchyAssignmentSchema } from "./index";

// ALERTS CRUD

export const getAlertsList = (state: State) => state.service.alerts.list || [];

export type GetAlertsList = (state: State) => Array<Alert>;
export const getAlertsActiveList: GetAlertsList = (state: State) => {
  return getAlertsList(state)
    .filter(c => c.approvalState.indexOf("ACTIVE_") !== -1)
    .reduce((acc, c) => (c.active ? [...acc, c.active] : acc), []);
};

export const getAlertsPendingList: GetAlertsList = (state: State) => {
  return getAlertsList(state)
    .filter(c => c.approvalState.indexOf("PENDING_REVIEW") !== -1)
    .reduce((acc, c) => (c.draft ? [...acc, c.draft] : acc), []);
};

export const getAlertsDraftList: GetAlertsList = (state: State) => {
  return getAlertsList(state)
    .filter(c => c.approvalState === "DRAFT_ONLY" || c.approvalState === "ACTIVE_WITH_DRAFT")
    .reduce((acc, c) => (c.draft ? [...acc, c.draft] : acc), []);
};

export const getCurrentAlert = (state: State): ?ApprovableContainer<Alert> =>
  state.service.alerts.current;

export const getAlertDraft = (state: State): ?Alert => state.service.alerts.draft;

export const getAlertAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.alerts.assignments;

export const getAlertDraftAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.alerts.draftAssignments;

export const isAlertDraftAssignmentsValid = (state: State): boolean => {
  const assignments = getAlertDraftAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const isAlertAssignmentsValid = (state: State): boolean => {
  const assignments = getAlertAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

// ALERTS SCHEMA

export const getAlertSchema = (state: State): Object | null => state.service.alerts.schema;

// ALERTS MODALS
export const getShowAlertAddRecipientModal = (state: State): boolean =>
  state.service.alerts.modals.showAddAlertRecipientModal;

export const getShowAlertAddAttachmentModal = (state: State): boolean =>
  state.service.alerts.modals.showAddAlertAttachmentModal;

export const getShowAlertDeleteAttachmentModal = (state: State): boolean =>
  state.service.alerts.modals.showDeleteAlertAttachmentModal;

export const getBespokeRecipient = (state: Object) => {
  return state.employees.employee.bespokeRecipient;
};
